
import LfDataService from '../Services/LfDataService';

export default class BasicCoverageHandler {
    constructor() {
        this.holder = document.getElementById('mypages-possession-teaser-root');
        this.lfDataService = new LfDataService();

        if (this.holder) {
            this.initialize();
        }
    }

    initialize = () => {
        const insuranceGroups = [...this.holder.querySelectorAll('[data-lf-epi-insurance-group]')]
            .map(div => div.dataset.lfEpiInsuranceGroup);
        this.lfDataService.possessionStatus(insuranceGroups).then(result => {

            const possessions = result.possessionStatus
                .filter(possession => !possession.hasInsurance && !possession.isFutureInsurance)
                .map(possession => {
                return possession.insuranceName;
            });

            if (possessions.length) {

                possessions.map(p => {
                    const parent = this.holder.querySelector('[data-lf-epi-insurance-group=' + p + ']').parentElement;

                    parent.style.visibility = 'visible';
                    parent.style.height = 'auto';
                    parent.style.opacity = '1';
                });
            } else {
                this.holder.classList.add('empty');
            }

        }).catch(error => {
            this.holder.classList.add('empty');
        }).finally(() => {
            this.holder.classList.remove('loading');
            this.holder.querySelector('.loader--active').classList.remove('loader--active');
        });
    }
}


